/* eslint-disable react/no-array-index-key */
import React from 'react';

const MatchingSetSkeleton = React.memo(({ count = 1 }) => (
  <div className="matching-set-skeleton__slider">
    {Array.from({ length: count }).map((_, idx) => (
      <div
        key={idx}
        className="matching-set-skeleton__card"
      >
        <div className="matching-set-skeleton__card-box" />
      </div>
    ))}
  </div>
));

export default MatchingSetSkeleton;
